<template>
  <div class="massLoss-list" v-loading="refreshLoading">
    <div class='tabs'>
      <div @click='typeFun(0)' class='left' :class='{ active: active === 0 }'>暂估收支</div>
      <div @click='typeFun(1)' class='right' :class='{ active: active === 1 }'>暂估3-2差异</div>
    </div>
    <div class="nav">
      <el-form :model="searchForm" label-width="60px" :inline="true" class="demo-form-inline flex1">
        <el-form-item label="年份：">
          <el-date-picker v-model="searchForm.years" size="mini" style="width: 150px" value-format="yyyy" type="year" placeholder="开始日期" />
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span="24" style="text-align: end; font-size: 14px !important" class="exportButton">
        <span @click="exportData">导出数据</span>
      </el-col>
    </el-row>
    <div class="content">
      <div class="tableContainer">
        <el-table
          ref="registerTable"
          row-key="id"
          v-loading="tableLoading"
          :data="tableData"
          style="width: 100%"
          :max-height="tableMaxHeight"
          border :header-cell-style="headerCellStyle" >
          <el-table-column label="序号" align="center" type="index" width="50px" />
          <el-table-column prop="stage" label="阶段" align="center" min-width="100px" />
          <el-table-column prop="month" label="台账月" align="center" min-width="100px" />
          <el-table-column prop="customerName" label="客户名称" align="center" min-width="100px" />
          <el-table-column prop="route" label="物流路线" align="center" min-width="140" />
          <el-table-column prop="transport" label="转运情况" align="center" min-width="180" show-overflow-tooltip/>
          <el-table-column prop="upAndDown" label="上下水" align="center" min-width="100px" />
          <el-table-column prop="brand" label="品牌" align="center" min-width="100px" />
          <el-table-column prop="quantity" label="数量" align="center" min-width="100px" />
          <el-table-column prop="frameNo" label="车架号" align="center" min-width="180px" />
          <el-table-column prop="totalIncome" label="收入合计" align="center" min-width="100px" />
          <el-table-column prop="totalExpenditure" label="支出合计" align="center" min-width="100px" />
          <el-table-column label="收入" align="center">
            <template>
              <el-table-column prop="incomeTransportSectionOne" label="运段1" align="center" min-width="140px" />
              <el-table-column prop="incomeTypeOne" label="运输方式1" align="center" min-width="100px" />
              <el-table-column prop="inTime1" label="集港时间" align="center" min-width="140px" v-if="active === 0"/>
              <el-table-column prop="incomePort" label="收入（集港费）" align="center" min-width="140px" />
              <el-table-column prop="incomeTransportSectionTwo" label="运段2" align="center" min-width="140px" />
              <el-table-column prop="incomeTypeTwo" label="运输方式2" align="center" min-width="100px" />
              <el-table-column prop="inTime2" label="装卸时间" align="center" min-width="140px" v-if="active === 0"/>
              <el-table-column prop="incomeLoadingAndUnloading" label="收入（装卸费）" align="center" min-width="140px" />
              <el-table-column prop="inTime3" label="江运时间" align="center" min-width="140px" v-if="active === 0"/>
              <el-table-column prop="incomeJiangYun" label="收入（江运费）" align="center" min-width="140px" />
              <el-table-column prop="incomeTransportSectionThree" label="运段3" align="center" min-width="140px" />
              <el-table-column prop="incomeTypeThree" label="运输方式3" align="center" min-width="100px" />
              <el-table-column prop="inTime4" label="配送时间" align="center" min-width="140px" v-if="active === 0"/>
              <el-table-column prop="incomeDeliveryFee" label="收入（配送费）" align="center" min-width="140px" />
            </template>
          </el-table-column>
          <el-table-column label="支出" align="center">
            <template>
              <el-table-column prop="costTransportSectionOne" label="运段1" align="center" min-width="140px" />
              <el-table-column prop="costTypeOne" label="运输方式1" align="center" min-width="100px" />
              <el-table-column prop="costTime1" label="集港时间" align="center" min-width="140px" v-if="active === 0"/>
              <el-table-column prop="costPort" label="支出（集港费）" align="center" min-width="140px" />
              <el-table-column prop="costTime2" label="提车时间" align="center" min-width="140px" v-if="active === 0"/>
              <el-table-column prop="costPicking" label="支出（提车费）" align="center" min-width="140px" />
              <el-table-column prop="costTransportSectionTwo" label="运段2" align="center" min-width="140px" />
              <el-table-column prop="costTypeTwo" label="运输方式2" align="center" min-width="100px" />
              <el-table-column prop="costTime3" label="装船时间" align="center" min-width="140px" v-if="active === 0"/>
              <el-table-column prop="costLoadingFee" label="支出（装船费）" align="center" min-width="140px" />
              <el-table-column prop="costTime4" label="卸船时间" align="center" min-width="140px" v-if="active === 0"/>
              <el-table-column prop="costUnloadingFee" label="支出（卸船费）" align="center" min-width="140px" />
              <el-table-column prop="costTime5" label="过驳时间" align="center" min-width="140px" v-if="active === 0"/>
              <el-table-column prop="costRefuelingFee" label="支出（过驳费）" align="center" min-width="140px" />
              <el-table-column prop="costTime6" label="江运时间" align="center" min-width="140px" v-if="active === 0"/>
              <el-table-column prop="costJiangYun" label="支出（江运费）" align="center" min-width="140px" />
              <el-table-column prop="costTime7" label="转船时间" align="center" min-width="140px" v-if="active === 0"/>
              <el-table-column prop="costTransshipment" label="支出（转船费）" align="center" min-width="140px" />
              <el-table-column prop="costTime8" label="堆存时间" align="center" min-width="140px" v-if="active === 0"/>
              <el-table-column prop="costStacking" label="支出（堆存费）" align="center" min-width="140px" />
              <el-table-column prop="costTransportSectionThree" label="运段3" align="center" min-width="140px" />
              <el-table-column prop="costTypeThree" label="运输方式3" align="center" min-width="100px" />
              <el-table-column prop="costTime9" label="配送时间" align="center" min-width="140px" v-if="active === 0"/>
              <el-table-column prop="costDeliveryFee" label="支出（配送费）" align="center" min-width="140px" />
            </template>
          </el-table-column>
          <el-table-column label="毛利" align="center">
            <el-table-column prop="grossProfitOne" label="公路" align="center" min-width="100px" />
            <el-table-column prop="grossProfitTwo" label="水路" align="center" min-width="100px" />
            <el-table-column prop="grossProfitThree" label="公路" align="center" min-width="100px" />
            <el-table-column prop="grossProfit" label="毛利合计" align="center" min-width="100px" />
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination
          background
          :page-sizes="[400, 800, 1200]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { differenceAnalysisList } from '@/service/financial';
  import { formatTime } from '@/config/mUtils';

  export default {
    name: 'dataDifferenceAnalysis',
    data() {
      return {
        refreshLoading: false,
        modeOfTransport: 1,
        incomeSegment: 1,
        expenseSegment: 1,
        searchForm: {
          years: '',
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        total: 0,
        windowHeight: 0,
        tableMaxHeight: 650,
        active: 0
      };
    },
    watch: {
      windowHeight() {
        this.getResolution(true);
      },
    },
    mounted() {
      // this.getDefaultDate();
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      this.getResolution();
    },
    filters:{
      formatTime(val){
        if(val){
          return formatTime(val, "yyyy")
        }else {
          return ''
        }

      }
    },
    methods: {
      typeFun(val) {
        this.active = val;
        this.tableData = [];
        this.searchForm.years = ''
      },
      getResolution(flag) {
        if (flag) {
          this.windowHeight === 1080 ? (this.tableMaxHeight = 650) : (this.tableMaxHeight = 380);
          this.$forceUpdate();
          return;
        }
        this.windowHeight = window.screen.height;
      },
      // getDefaultDate() {
      //   const date = new Date();
      //   this.searchForm.years = date.getFullYear().toString();
      // },
      // 导出数据
      exportData() {
        window.exportExcelAllFunc({
          type: 'get',
          url: '/yearMonthPlan/all/exportXls',
          obj:{
            month:this.searchForm.years,
            version:  this.active === 0 ? 3 : 6,
            stage: this.active === 1 ? '暂估3-2差异' : ''
          }
        })
      },
      // 查询
      searchBtn() {
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const { status, message, data } = await differenceAnalysisList({
          month:this.searchForm.years,
          version: this.active === 0 ? 3 : 6,
          stage: this.active === 1 ? '暂估' : ''
        });
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total
      },
      contractSizeChange() {
        this.getTableData();
      },
      contractCurrentChange() {
        this.getTableData();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 200px;
      margin-bottom: 20px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599E;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599E;
        font-weight: 700;
        transition: all .3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .right {
        width: 150px;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }

      .active {
        background: #48599E;
        color: #fff;
      }
    }
    .nav {
      width:100%;
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }

    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }
            }
          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #ffffff;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }
    }
  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      margin-right: 10px;
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
